import axios from "axios";
import {
  CorpDetailModel,
  CorpInfoModel,
  CorpModel,
  CorpSearchOptions,
  PublicCorpListModel,
} from "models";
import { IAPIResult } from "models/interfaces";

// 会社情報の一覧
export async function search(options: CorpSearchOptions) {
  // await Utils.sleep(300);
  const response = await axios.post<IAPIResult<PublicCorpListModel>>(
    "/api.d/v1/ec/corp/public-search",
    options
  );

  return response.data;
}

// 会社名の一覧（非公開リスト/限定公開リスト で仕様）
export async function list() {
  // await Utils.sleep(300);
  const response = await axios.get<IAPIResult<CorpModel[]>>(
    "/api.d/v1/ec/corp/list"
  );
  return response.data;
}

export async function info() {
  // await Utils.sleep(300);

  const response = await axios.get<IAPIResult<CorpInfoModel>>(
    "/api.d/v1/ec/corp/detail"
  );
  return response.data;
}

export async function detail(corp_id: string) {
  // await Utils.sleep(300);
  const response = await axios.get<IAPIResult<CorpDetailModel>>(
    "/api.d/v1/ec/corp/public-detail",
    { params: { corp_id } }
  );

  if (response.data) {
    const tmp = response.data.data;
    if (tmp.pr_image_text_1 === null) {
      tmp.pr_image_text_1 = "";
    }
    if (tmp.pr_image_text_2 === null) {
      tmp.pr_image_text_2 = "";
    }
    if (tmp.pr_image_text_3 === null) {
      tmp.pr_image_text_3 = "";
    }
  }
  return response.data;
}

export async function limitPrice() {
  const response = await axios.get<IAPIResult>("/api.d/v1/ec/corp/limit-price");
  return response.data;
}
